import { useMemo } from 'react';
import { ProductTransferListResponseDto } from '@tiendanube/common';
import { useListMobile } from 'App/hooks';
import { TransfersEndpoints } from '../transfersApi';

export function useTransfersMobile() {
  const result = useListMobile<ProductTransferListResponseDto[number]>({
    filters: { perPage: '20' },
    endpoint: TransfersEndpoints.getTransfersListInf,
  });

  const ids = useMemo(
    () => result.data.map((current) => current.id),
    [result.data],
  );

  return { ...result, ids };
}
